<template>
  <div class="asc-grid-wrapper--wrap">
    <asc-surface-title
      :title="title"
      class="asc-grid-wrapper--title"
    ></asc-surface-title>
    <template v-if="isTooltipShown">
      <div class="asc-grid-wrapper--icon-wrap">
        <asc-tooltip
          :tooltip="tooltip"
          bottom
          is-icon-tooltip
          :max-width="'300'"
        >
          <span class="asc-icon">
            <v-icon class="icon-info">mdi-information</v-icon>
          </span>
        </asc-tooltip>
      </div>
    </template>
  </div>
</template>

<script>
import AscTooltip from '@/components/atoms/AscTooltip'
import AscSurfaceTitle from '../atoms/AscSurfaceTitle.vue'

export default {
  name: 'AscGridWrapperTitle',

  components: {
    AscTooltip,
    AscSurfaceTitle,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
  },

  computed: {
    isTooltipShown() {
      return this.tooltip && this.tooltip.length > 0
    },
  },
}
</script>

<style lang="scss">
.asc-grid-wrapper--wrap {
  flex: 1;
  display: flex;
  align-items: baseline;

  .asc-grid-wrapper--title {
    text-transform: uppercase;
  }

  .asc-icon {
    display: inline-block;
    top: -2px;
    padding-left: $spacing-sm;
    position: relative;
  }

  .asc-icon .icon-info {
    color: $accent-500;
    cursor: pointer;
    display: inline-block;
    font-size: $font-size-lrg;
  }
}
</style>
